export default __webpack_public_path__ + "c3220a4c330b40222e6754b7d61669f6.jpg";